import { useCallback } from "react";
import { fetchNoctisDashboardStatus, getCachedNoctisDashboardStatus } from "../api/dashboard.api";
import { useCachedDashboardQuery } from "./useCachedDashboardQuery";

export const useNoctisDashboardStatus = (enabled: boolean) => {
  const fetcher = useCallback((force?: boolean) => fetchNoctisDashboardStatus(force), []);
  return useCachedDashboardQuery(enabled, getCachedNoctisDashboardStatus, fetcher);
};
